import { Component, HostListener, OnInit } from '@angular/core';
import { isNullOrUndefined } from 'util';
import { ClientDataService } from '../services/client-data.service';
declare var $: any;
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  CompanyName: string = '';
  IsMobile: boolean = false;
  ARNNo: string = '';
  FromDate: string = '';
  ToDate: string = '';
  constructor(private ClientDataService: ClientDataService) {}
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.SetViewPort(event.target.innerWidth);
  }
  ngOnInit() {
    this.CompanyName = this.ClientDataService.GetCompanyName();
    this.SetViewPort(window.innerWidth);
    setTimeout(() => {
      this.ARNNo = isNullOrUndefined(sessionStorage.getItem('ihjt45h45=q'))
        ? sessionStorage.getItem('lkighty445dh==RegNo')
        : sessionStorage.getItem('ihjt45h45=q');

      this.CompanyName = !isNullOrUndefined(
        sessionStorage.getItem('ihjt45h45=CompanyName')
      )
        ? sessionStorage.getItem('ihjt45h45=CompanyName')
        : sessionStorage.getItem('lkighty445dh==AppName');
      this.FromDate = !isNullOrUndefined(
        sessionStorage.getItem('lkighty445dh==FromDate')
      )
        ? sessionStorage.getItem('lkighty445dh==FromDate')
        : '';
      this.ToDate = !isNullOrUndefined(
        sessionStorage.getItem('lkighty445dh==ToDate')
      )
        ? sessionStorage.getItem('lkighty445dh==ToDate')
        : '';
    }, 2000);
  }
  OpenContactUs() {
    // $(".modal").modal('hide');
    $('#ContactUsModal').modal({
      backdrop: 'static',
      keyboard: false
    });
  }
  SetViewPort(w) {
    if (w <= 767) {
      this.IsMobile = true;
    } else {
      this.IsMobile = false;
    }
  }
  ShowDisclaimer() {
    $('#DisclaimerModal').modal({
      backdrop: 'static',
      keyboard: false
    });
  }
}
